import business from './business'
import customer from './customer'
import payment from './payment'

export default {
  business,
  customer,
  payment
}



// WEBPACK FOOTER //
// ./src/api/apis/self/sales/index.js